<div class="expectation-container">
  <h2 class="column twelve lg-push-two lg-eight">
    <b>{{ expectationContent?.headerText }}</b>
  </h2>

  <div class="pad-top-20 row column twelve lg-push-two lg-eight">
    <div class="flex">
      <div class="counter">1</div>
      <div
        class="pad-left-10"
        dsContent
        [contentPath]="'policy.addVehicleExpectations[0].text'"
      ></div>
    </div>
    <a
      href="#"
      class="pad-left-30"
      data-cy="expectationSettingFindMyVin"
      (click)="findVIN($event)"
      >{{ vinContent?.linkText }}</a
    >
  </div>

  <div class="pad-top-20 row column twelve lg-push-two lg-eight">
    <div class="flex">
      <div class="counter">2</div>
      <div
        class="pad-left-10"
        dsContent
        [contentPath]="'policy.addVehicleExpectations[1].text'"
        [options]="{
          titleHolders: (titleHolders$ | async),
          plural: plural ? 's' : ''
        }"
      ></div>
    </div>
  </div>

  <div class="pad-top-20 row column twelve lg-push-two lg-eight">
    <div class="flex">
      <div class="counter">3</div>
      <div
        class="pad-left-10"
        dsContent
        [contentPath]="'policy.addVehicleExpectations[2].text'"
      ></div>
    </div>
  </div>

  <div class="pad-top-20 row column twelve lg-push-two lg-eight">
    <div class="flex">
      <div class="counter">4</div>
      <div
        class="pad-left-10"
        dsContent
        [contentPath]="'policy.addVehicleExpectations[3].text'"
      ></div>
    </div>
  </div>

  <div class="column twelve lg-push-two lg-eight pad-top-20">
    {{
      (isPartner$ | async)
        ? expectationContent?.sendToAdvisorText
        : expectationContent?.sendToAgentText
    }}
  </div>

  <div class="column twelve lg-push-two lg-eight">
    <call-to-action
      [displayBackButton]="true"
      tertiaryButtonName="Cancel"
      primaryButtonName="Continue"
      [secondaryButtonName]="(isPartner$ | async) ? 'Send to an advisor' : 'SEND TO MY AGENT'"
      (secondaryEvent)="sendToMyAgent()"
      (backEvent)="goBack()"
      (tertiaryEvent)="cancel()"
      (primaryEvent)="continue()"
    ></call-to-action>
  </div>
</div>

<amfam-find-vin-modal [vinContent]="vinContent" [findVinFlowModalId]="findVinFlowModalId">
</amfam-find-vin-modal>
<ds-agent-selection-modal
  [agentSelectionModalId]="agentSelectorModalID"
  [agents]="policyAgents$ | async"
  (confirmAgentSelection)="agentConfirmationFromModal($event)"
></ds-agent-selection-modal>
